import { Day } from "../types/Day";

// i18n keys for day names
export const DAY_NAME_KEYS: Record<Day, string> = {
	[Day.MONDAY]: "days.monday",
	[Day.TUESDAY]: "days.tuesday",
	[Day.WEDNESDAY]: "days.wednesday",
	[Day.THURSDAY]: "days.thursday",
	[Day.FRIDAY]: "days.friday",
	[Day.SATURDAY]: "days.saturday",
	[Day.SUNDAY]: "days.sunday",
};

// Day abbreviations
export const DAY_ABBREVIATIONS: Record<Day, string> = {
	[Day.MONDAY]: "Mon",
	[Day.TUESDAY]: "Tue",
	[Day.WEDNESDAY]: "Wed",
	[Day.THURSDAY]: "Thu",
	[Day.FRIDAY]: "Fri",
	[Day.SATURDAY]: "Sat",
	[Day.SUNDAY]: "Sun",
};

// Default selected days (weekdays + saturdays)
export const DEFAULT_SELECTED_DAYS: Day[] = [
	Day.MONDAY,
	Day.TUESDAY,
	Day.WEDNESDAY,
	Day.THURSDAY,
	Day.FRIDAY,
	Day.SATURDAY,
];

// All days array for iteration
export const ALL_DAYS: Day[] = [
	Day.MONDAY,
	Day.TUESDAY,
	Day.WEDNESDAY,
	Day.THURSDAY,
	Day.FRIDAY,
	Day.SATURDAY,
	Day.SUNDAY,
];
